<div class="listingFacet" [ngClass]="{'-open': contentVisible}">
  <header class="listingFacet_header">
    <button class="listingFacet_showButton flaticon-down-arrow" (click)="toggleContentVisibility()" type="button">
      {{facet.name}} <span *ngIf="selectedCounter > 0">(<b>{{selectedCounter}}</b>)</span></button>
  </header>
  <div class="listingFacet_content">
    <v-facet-search-bar *ngIf="facet.code === 'brandName'" [progressing]="processing" (changeVal)="filterItems($event)"></v-facet-search-bar>
    <ul *ngIf="elements" class="listingFacet_list">
      <li *ngFor="let element of elements | slice:0:end; let i = index; trackBy: getCodeTracking">
        <div class="listingFacet_checkbox">
          <input [disabled]="processing" type="checkbox" [id]="facet.code+'-'+i" [name]="element.code" [checked]="element.selected" (change)="checkFacet(facet.code, facet.webname, element.code, $event)">
          <label [htmlFor]="facet.code+'-'+i">{{element.name | title}} ({{element.count}})</label>
        </div>
      </li>
    </ul>
    <p *ngIf="!elements.length" class="listingFacet_emptyList">{{'listing.facets.facet.search.empty' | translate}}</p>
    <button *ngIf="facet.values.length > limit && !searching" (click)="toggleElementsVisibility()"
                 [innerHTML]="(showMore ? 'listing.facets.facet.showMore' : 'listing.facets.facet.showLess') | translate"
                 class="listingFacet_moreButton" type="button">
    </button>
    <button *ngIf="facet.code === 'brandName' && showPickButton" (click)="closeFacets.emit()" class="listingFacet_pickButton" type="button" [disabled]="processing">
      {{'listing.facets.facet.pickSelected' | translate}}
      <v-spinner [activeSpinner]="processing"></v-spinner>
    </button>
  </div>
</div>
